module.exports = __webpack_public_path__ + "static/media/ts.881d5842.svg";